export const CAT_FETCH_REQUEST = "CAT_FETCH_REQUEST";
export const CAT_FETCH_SUCCESS = "CAT_FETCH_SUCCESS";
export const CAT_FETCH_FAILS = "CAT_FETCH_FAILS";

export const CAT_FETCH_BY_ID_REQUEST = "CAT_FETCH_BY_ID_REQUEST";
export const CAT_FETCH_BY_ID_SUCCESS = "CAT_FETCH_BY_ID_SUCCESS";
export const CAT_FETCH_BY_ID_FAILS = "CAT_FETCH_BY_ID_FAILS";

export const CAT_DELETE_REQUEST = "CAT_DELETE_REQUEST";
export const CAT_DELETE_SUCCESS = "CAT_DELETE_SUCCESS";
export const CAT_DELETE_FAILS = "CAT_DELETE_FAILS";
export const CAT_DELETE_RESET = "CAT_DELETE_RESET";

export const CAT_UPDATE_REQUEST = "CAT_UPDATE_REQUEST";
export const CAT_UPDATE_SUCCESS = "CAT_UPDATE_SUCCESS";
export const CAT_UPDATE_FAILS = "CAT_UPDATE_FAILS";
export const CAT_UPDATE_RESET = "CAT_UPDATE_RESET";

export const CAT_CREATE_REQUEST = "CAT_CREATE_REQUEST";
export const CAT_CREATE_SUCCESS = "CAT_CREATE_SUCCESS";
export const CAT_CREATE_FAILS = "CAT_CREATE_FAILS";
export const CAT_CREATE_RESET = "CAT_CREATE_RESET";
